<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.questionCategory">
        <el-option
          v-for="(item, i) in questionCategoryData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.examQuestionType"
        disabled
      >
        <el-option
          v-for="(item, i) in questionTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item style="margin-left: 22px;">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.questionTitle"
        placeholder="试题题干"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-right: 0px;">
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  // 使用jnject获取祖先组件传过来的值
  inject: ["getQuestionCategoryData", "getQuestionTypeData", "getQuestionType"],
  components: { butn },
  data() {
    return {
      filters: {
        questionCategory: "",
        examQuestionType: this.getQuestionType()
      }
    };
  },
  computed: {
    questionCategoryData() {
      let array = this.getQuestionCategoryData();
      if (array.length > 3) {
        return array;
      }
      // unshift() 方法无法在 Internet Explorer 中正确地工作！
      // array.unshift({
      //   paramKey: "",
      //   paramValue: "全部分类"
      // });
      array.splice(0, 0, {
        paramKey: "",
        paramValue: "全部分类"
      });
      return array;
    },
    questionTypeData() {
      return this.getQuestionTypeData();
    }
  },
  methods: {
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {
        questionCategory: "",
        examQuestionType: this.getQuestionType()
      };
      this.$emit("search", this.filters);
    }
  }
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
